import React from 'react';
import { APP_CONFIG } from '../../../../configs/config';

export default function RateLimitModal({ message, onClose }) {
  const handleSignIn = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `${APP_CONFIG.MAIN_WEBSITE_ORIGIN}/signin?returnUrl=${returnUrl}`;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-gray-800 to-purple-900 rounded-3xl p-8 max-w-md w-full shadow-2xl border border-white/10">
        <h2 className="text-2xl font-bold text-yellow-400 mb-4 text-center">
          Sign in required
        </h2>
        <p className="text-white/90 text-center mb-6">
          {message || 'You have reached the maximum number of requests. Please sign in to continue using this service.'}
        </p>
        <div className="flex flex-col gap-3">
          <button
            onClick={handleSignIn}
            className="w-full px-6 py-3 rounded-2xl font-semibold text-gray-900 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 shadow-lg transition-all"
          >
            Go to Sign In
          </button>
          {onClose && (
            <button
              onClick={onClose}
              className="w-full px-6 py-3 rounded-2xl font-semibold text-white bg-white/10 hover:bg-white/20 transition-colors border border-white/15"
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

